import React, { useState, useEffect, useCallback, useRef } from 'react';

import { useCredentials } from 'hooks/credentials';
import { useToast } from 'hooks/toast';

import SGOHeader from 'components/SGOHeader';
import SGONavbar from 'components/SGONavbar';
import SGOFooter from 'components/SGOFooter';
import Loading from 'components/Loading';
import ScrollTop from 'components/ScrollTop';
import Button from 'components/Button';
import RadioContainer from 'components/RadioContainer';

import api from 'services/api';
import * as yup from 'yup';
import getValidationErrors from 'utils/getValidationErrors';

import { Container, Content } from 'styles/sgo_wrappers';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import Input from 'components/Input';
import { useHistory, useLocation } from 'react-router-dom';

import { ListProps } from '../main';
import { Wrapper } from '../insert/styles';

interface FormData {
  type: string;
  description: string;
  status: string;
  cod: string;
}

const ReceitasDespesasUpdate: React.FC = () => {
  const location = useLocation<ListProps>();
  const history = useHistory();
  const { handlePermission, errorHandling } = useCredentials();
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);

  const [record] = useState<ListProps>(() => {
    return ({ ...location.state } || {}) as ListProps;
  });

  useEffect(() => {
    // console.table(record);
    handlePermission(['ZON'], true);
  }, [handlePermission]);

  const handleSubmit = useCallback(
    async (data: FormData) => {
      setLoading(true);
      try {
        formRef.current?.setErrors({});

        const schema = yup.object().shape({
          description: yup
            .string()
            .trim()
            .min(4, 'Quantidade mínima de caracteres não atingida (4).')
            .max(60, 'Quantidade máxima de caracteres excedida (60).'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const send = new FormData();
        send.append('data', JSON.stringify({ ...data, mode: 'update' }));

        await api.post('/sgo/recdespeventos.php', send, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        addToast({
          type: 'success',
          title: 'Sucesso!',
          description: 'Registro inserido.',
        });
        history.goBack();
      } catch (err) {
        if (err instanceof yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);
          return;
        }
        errorHandling(err);
      } finally {
        setLoading(false);
      }
    },
    [addToast, errorHandling, history],
  );

  return (
    <Container>
      <Loading isLoading={loading} />
      <ScrollTop />
      <SGOHeader />
      <SGONavbar noLinks title="Alteração Receita/Despesa" />
      <Content>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <Input isHidden name="cod" value={record.cod} />
          <Wrapper>
            <div>
              <p>Tipo:</p>
              <RadioContainer
                selected={record.type}
                name="type"
                content={[
                  {
                    id: 'tR',
                    value: 'R',
                    label: 'Receita',
                  },
                  {
                    id: 'tD',
                    value: 'D',
                    label: 'Despesa',
                  },
                ]}
              />
            </div>
            <div>
              <p>Descrição:</p>
              <Input
                name="description"
                defaultValue={record.desc}
                placeholder="Descrição"
              />
            </div>
            <div>
              <p>Situação:</p>
              <RadioContainer
                selected={record.status ? '1' : '0'}
                name="status"
                content={[
                  {
                    id: 'sA',
                    value: '1',
                    label: 'Ativa',
                  },
                  {
                    id: 'sD',
                    value: '0',
                    label: 'Desativada',
                  },
                ]}
              />
            </div>
          </Wrapper>

          <Button type="submit" bgcolor="#00802b">
            Finalizar
          </Button>
        </Form>
      </Content>
      <SGOFooter />
    </Container>
  );
};

export default ReceitasDespesasUpdate;
